import React from 'react';
import { useAudio } from '../../../contexts/AudioContext';
import { useTranslation } from '../../../i18n';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WelcomeOverlay = ({ guestName, coupleNames, weddingDate, venue, welcomeMessage, onDismiss }) => {
  const { play } = useAudio();
  const { t } = useTranslation();

  const handleDismiss = () => {
    play(); // Start audio autoplay on user interaction
    onDismiss();
  };

  return (
    <div className="fixed inset-0 z-1200 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-card rounded-2xl shadow-romantic-2xl max-w-md w-full p-6 md:p-8 text-center">
        <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-6 bg-primary/10 rounded-full flex items-center justify-center">
          <Icon name="Heart" size={32} color="var(--color-primary)" />
        </div>
        
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4">
          {`${t('welcome.title')}${guestName ? `, ${guestName}` : ''}!`}
        </h2>
        
        <p className="text-base md:text-lg text-muted-foreground mb-6 font-caption">
          {welcomeMessage || t('welcome.inviteMessage')}
        </p>
        
        <h3 className="text-3xl md:text-4xl font-serif text-primary mb-8">
          {coupleNames || 'Sarah & Michael'}
        </h3>
        
        <div className="space-y-3 mb-6">
          <div className="flex items-center justify-center gap-3 text-sm md:text-base text-foreground">
            <Icon name="Calendar" size={20} color="var(--color-primary)" />
            <span className="font-caption">{weddingDate || 'June 15, 2026'}</span>
          </div>
          <div className="flex items-center justify-center gap-3 text-sm md:text-base text-foreground">
            <Icon name="MapPin" size={20} color="var(--color-primary)" />
            <span className="font-caption">{venue || 'The Grand Ballroom, New York'}</span>
          </div>
        </div>
        
        <p className="text-sm md:text-base text-muted-foreground mb-8 font-caption">
          {t('welcome.exploreHint')}
        </p>
        
        <Button
          variant="default"
          size="lg"
          fullWidth
          onClick={handleDismiss}
          iconName="ArrowRight"
          iconPosition="right"
        >
          {t('welcome.viewInvitation')}
        </Button>
      </div>
    </div>
  );
};

export default WelcomeOverlay;